export default {
  createHeader: 'Create event tag',
  editHeader: 'Edit event tag',
  duplicateDisplayName: 'A tag with this name already exists.',
};
